import { MutationObserver } from "@tanstack/query-core";
import type { CreateWorldParams } from "api-contracts/rpc/create-world";
import type { DeleteWorldParams } from "api-contracts/rpc/delete-world";
import type { UpdateWorldParams } from "api-contracts/rpc/update-world";
import { queryClient } from "ui-common/data-query-controller";
import { rpc } from "ui-common/services/rpc";

export const createWorldMutation = new MutationObserver(queryClient, {
  mutationKey: ["createWorld"],
  mutationFn: (params: CreateWorldParams) => rpc("createWorld", params),
  onSuccess: () => queryClient.invalidateQueries({ queryKey: ["worlds"] }),
});

export const updateWorldMutation = new MutationObserver(queryClient, {
  mutationKey: ["updateWorld"],
  mutationFn: (params: UpdateWorldParams) => rpc("updateWorld", params),
  onSuccess: () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: ["worlds"] }),
      queryClient.invalidateQueries({ queryKey: ["posts"] }),
    ]),
});

export const deleteWorldMutation = new MutationObserver(queryClient, {
  mutationKey: ["deleteWorld"],
  mutationFn: (params: DeleteWorldParams) => rpc("deleteWorld", params),
  onSuccess: () => queryClient.invalidateQueries({ queryKey: ["worlds"] }),
});
